module.exports = __webpack_public_path__ + "img/liveNum13.dcf885b2.png";